import React from 'react';
import { getOtherHeader, getOtherDescription } from './Utils';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleTwo/Dialog';
import OtherOptionDialogActions from './OtherOptionDialogActions';

export default function RequestChangeDialog({
  stepNumber,
  setStepNumber,
  otherOptionsOpen,
  setOtherOptionsOpen,
}) {
  const onCloseOtherOptions = () => {
    setOtherOptionsOpen(false);
  };

  return (
    <>
      <Dialog
        open={otherOptionsOpen}
        header={getOtherHeader(stepNumber)}
        description={getOtherDescription(stepNumber)}
        actions={
          <OtherOptionDialogActions
            step={stepNumber}
            setStepNumber={setStepNumber}
          />
        }
        onClose={onCloseOtherOptions}
      />
    </>
  );
}
